import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

import { countryPhoneCodes } from './utils/country-codes';

const UPDATE_USER_MUTATION = gql(`
  mutation UpdateUser(
    $id: ID!
    $name: String!
    $email: String!
    $phoneNumber: String
    $howDidYouHearAboutUs: String
  ) {
    updateUser(
      id: $id
      name: $name
      email: $email
      phoneNumber: $phoneNumber
      howDidYouHearAboutUs: $howDidYouHearAboutUs
    ) {
      id
      name
      email
      phoneNumber
      howDidYouHearAboutUs
      countryCode
      slug
      updatedAt
    }
  }
`);

const UpdateUser: FC<{
  id: string;
  name: string;
  email: string;
  phoneNumber?: string | null;
  countryCode?: string | null;
  howDidYouHearAboutUs?: string | null;
}> = ({ id, name, email, phoneNumber, countryCode, howDidYouHearAboutUs }) => {
  const [updateUser, { loading, error }] = useMutation(UPDATE_USER_MUTATION);

  return (
    <FormPanelWithReadMode
      loading={loading}
      error={error}
      onSubmit={data => {
        updateUser({
          variables: {
            id,
            name: data.name,
            email: data.email,
            phoneNumber: data.countryCode
              ? data.countryCode + '-' + data.phoneNumber
              : data.phoneNumber,
            howDidYouHearAboutUs: data.howDidYouHearAboutUs,
          },
        });
      }}
      title="Information"
    >
      <FormInput
        type="text"
        fieldName="name"
        label="Full Name *"
        defaultValue={name}
        validators={{
          required: true,
        }}
      />
      <FormInput
        type="text"
        fieldName="email"
        label="Email"
        defaultValue={email}
        validators={{
          required: true,
          isEmail: true,
        }}
      />
      <FormInput
        type="dropdown"
        fieldName="countryCode"
        options={countryPhoneCodes}
        label="Country Code"
        defaultValue={countryCode}
        validators={{
          isCountryCode: true,
        }}
      />
      <FormInput
        type="text"
        fieldName="phoneNumber"
        label="Phone Number"
        defaultValue={phoneNumber}
        validators={{
          isPhoneNumber: true,
        }}
      />
      <FormInput
        type="text"
        fieldName="howDidYouHearAboutUs"
        label="How did you learn about the AngelList India RUV?*"
        defaultValue={howDidYouHearAboutUs}
        validators={{
          maxLength: 255,
        }}
      />
    </FormPanelWithReadMode>
  );
};

export default UpdateUser;
